<template>
  <div>
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="editTransTypeModal"
        persistent
        max-width="540px"
      >
        <v-card>
          <form @submit.prevent="submitForm()">
            <v-card-title>
              <v-flex
                xs11
                sm11
                md11
              ><span class="headline">{{ $t('editTransportationType.title') }}</span></v-flex>
              <v-flex
                xs1
                sm1
                md1
              >
                <v-btn
                  flat
                  @click="$emit('close')"
                  class="close"
                ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex
                    xs12
                    sm5
                    md5
                  >
                    <v-select
                      v-model="form.transportation_type"
                      :items="form.warehouse ? form.warehouse.transportation_types : []"
                      item-value="id"
                      item-text="name"
                      :error-messages="errors.collect('Transportation Type')"
                      data-vv-name="Transportation Type"
                      :label="$t('columns.transportationType') + '*'"
                      v-validate="'required'"
                    />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                id="sendButton"
                type="submit"
                style="height:auto" class="rtl-mr-20"
                outline
                color="success"
              >{{ $t('common.save') }}</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios'
import swal from 'sweetalert'
export default {
  props: [
    'editTransTypeModal',
    'form'
  ],

  methods: {
    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          let token = localStorage.getItem('access_token')

          Axios.put(`api/order/${this.form.order_id}/change-transportation-type`, this.form, { headers: { Authorization: 'Bearer ' + token } })
            .then(() => {
              swal(this.$t('common.done'), '', 'success')
              this.$emit('close')
              this.$emit('update-data')
            })
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/editTransportationType.vue